export default __webpack_public_path__ + "static/media/worker_download.d466b01e.png";